import AuthClient from './AuthClient';
/**
 * Idea: Provide a factory method for creating
 * a new AuthClient instance. A factory is more
 * of a JS method of using libraries like this.
 *
 * Patterns used: [Factory]
 */
function createAuthClient(options) {
    return new AuthClient(options);
}
export default createAuthClient;
